import { injectReportMethod } from '@tencent/fit-bi-sdk';
import { elk } from '@tencent/ppd-base-libs';
import { url } from '@tencent/wphk-base-utils';

/**
 * @description 将bi数据上报到es平台,在main.ts中引入使用
 * @param whiteList bi上报标签的白名单
 */
export const addBiToESIntercept = (whiteList: string[]) => {
  function reportBiToES(tag: string, ext?: object) {
    const isInTagsWhiteList = whiteList.some((item) => tag.includes(item));

    if (isInTagsWhiteList) {
      elk({
        key: 'biHottag',
        str1: tag,
        str4: url.getUrlAdtag(),
        body: ext,
      });
    }
  }
  injectReportMethod(reportBiToES, true);
};
